import React from 'react';
import { Tag } from 'antd';
import { Inbox } from '../../../types/index';
import { Link } from 'react-router-dom';

export const getClientOverviewTableColumns = (onClickUrl: (inbox: Inbox) => any) => {
  return [
    {
      title: 'Document Type',
      key: 'document_type',
      dataIndex: 'documentType',
      render: (text: string, inbox: Inbox) => (
        <span>
          <Link className="my-1" to={onClickUrl(inbox)}>
            {inbox.document_class}
          </Link>
        </span>
      ),
    },
    {
      title: 'Inbox Size',
      key: 'document_count',
      dataIndex: 'document_count',
      render: (text: number, inbox: Inbox) => {
        return (
          <span>
            <Tag color={'grey'} key={'Size'}>
              {inbox.nrofdocumentsforclass} documents
            </Tag>
          </span>
        );
      },
    },
    {
      title: 'Status',
      key: 'staged_document_count',
      dataIndex: 'staged_document_count',
      render: (text: string, inbox: Inbox) => (
        <span>
          {parseInt(inbox.nrofstageddocumentsforclass) === 0 ? (
            <Tag color={'green'} key={'READY'}>
              no staged documents
            </Tag>
          ) : (
            <Tag color={'red'} key={'READY'}>
              {inbox.nrofstageddocumentsforclass || 0} staged document
              {parseInt(inbox.nrofstageddocumentsforclass) > 1 ? 's' : ''}
            </Tag>
          )}
        </span>
      ),
    },
  ];
};
